import { useTranslation } from "react-i18next";
import { featuredCategories } from "@/mocks/categories";

export default function FeaturedCategories() {
  const { t } = useTranslation();

  const imageUrls: Record<string, string> = {
    "feat-img-shoes": "https://readdy.ai/api/search-image?query=Lifestyle%20product%20photography%20of%20premium%20minimalist%20sneakers%20placed%20on%20warm%20terracotta%20toned%20surface%20with%20soft%20directional%20window%20light%2C%20clean%20modern%20aesthetic%2C%20subtle%20plant%20shadow%20overlay%2C%20editorial%20fashion%20catalog%20style%2C%20warm%20earthy%20tones%20with%20creamy%20highlights%2C%20sophisticated%20composition&width=800&height=1000&seq=feat-shoes-v2-2026&orientation=portrait",
    "feat-img-acc": "https://readdy.ai/api/search-image?query=Elegant%20flatlay%20of%20fashion%20accessories%20including%20designer%20watch%20leather%20bracelet%20and%20premium%20sunglasses%20scattered%20on%20soft%20warm%20beige%20linen%20fabric%2C%20diffused%20natural%20morning%20light%2C%20minimalist%20editorial%20product%20photography%2C%20sophisticated%20neutral%20palette%2C%20organic%20arrangement%20with%20intentional%20negative%20space&width=800&height=1000&seq=feat-acc-v2-2026&orientation=portrait",
    "feat-img-hoodies": "https://readdy.ai/api/search-image?query=Premium%20quality%20hoodie%20sweater%20draped%20casually%20over%20modern%20minimal%20chair%20in%20sunlit%20room%2C%20warm%20oatmeal%20tones%2C%20soft%20natural%20light%20through%20sheer%20curtains%2C%20editorial%20fashion%20photography%2C%20cozy%20yet%20elevated%20aesthetic%2C%20clean%20Scandinavian%20interior%20background&width=800&height=1000&seq=feat-hoodies-v2-2026&orientation=portrait",
  };

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-start justify-between mb-10">
          <div className="flex items-center gap-3">
            <span className="text-xs font-body font-medium tracking-[0.2em] uppercase text-foreground-500 whitespace-nowrap">
              OOPBUY
            </span>
            <span className="text-xs font-body font-medium tracking-[0.2em] uppercase text-foreground-400">/</span>
            <span className="text-xs font-body font-medium tracking-[0.2em] uppercase text-foreground-500 whitespace-nowrap">
              SHEETS
            </span>
          </div>
          <h2 className="text-2xl md:text-4xl font-heading font-semibold text-foreground-950 text-right">
            {t("features.title")}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {featuredCategories.map((cat) => (
            <a
              key={cat.id}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="relative rounded-2xl overflow-hidden h-[380px] md:h-[440px] group cursor-pointer"
            >
              <img
                src={imageUrls[cat.imageSeq]}
                alt={cat.name}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent"></div>
              <div className="absolute top-4 left-4">
                <span className="px-3 py-1 rounded-full bg-background-50/80 backdrop-blur-sm text-xs font-medium text-foreground-800 whitespace-nowrap">
                  <i className="ri-fire-line text-primary-500 mr-1"></i>
                  {cat.tag}
                </span>
              </div>
              <div className="absolute bottom-6 left-6 right-6">
                <span className="text-2xl md:text-3xl font-heading font-bold text-background-50 block mb-1">
                  {cat.name}
                </span>
                <p className="text-sm text-background-100/70">Bulk order templates ready</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}